const decode =
    typeof atob === 'function' ? atob : (str: string) => Buffer.from(str, 'base64').toString();
export function decode64(encoded = ''): string {
    try {
        return decode(encoded);
    } catch (e) {
        return '';
    }
}
